import { useState } from 'react'
import cx from 'classnames'
import { useStores } from 'hooks/useStores'
import { observer } from 'mobx-react'
import { CardBody, CardTitle, CardText, CardProps, DropdownItem } from 'reactstrap'
import { deleteCollectionMainMedia } from 'API/collection'
import { deleteMediaById } from 'API/media'
import Card from 'components/Card'
import DropdownMenu from 'components/DropdownMenu'
import InlineTextField from 'components/InlineTextField'
import MediaThumbnail from 'components/MediaThumbnail'
import { getRenderProcess } from 'components/Pages/ProcessDetailPage/utils'
import { MediaType } from 'constants/media'
import { IMedia } from 'interfaces/media'
import styles from './mediaCard.module.scss'

interface MediaItemProps extends CardProps {
  media: IMedia & { collectionId?: number }
  onChangeCaption?: Function
  noEditCaption?: boolean
}
const MediaItem = ({
  media,
  noEditCaption = false,
  className,
  onChangeCaption = () => {},
  ...props
}: MediaItemProps) => {
  const { processStore, collectionStore } = useStores()
  const [editing, setEditing] = useState<boolean>(false)

  async function handleDeleteMedia() {
    if (media.collectionId) {
      await deleteCollectionMainMedia(media.collectionId)
      collectionStore.getCollectDetail(media.collectionId)
      return
    }
    await deleteMediaById(media.id)

    getRenderProcess(processStore.process.id, processStore)
  }

  return (
    <Card className={cx(styles.mediaCard, className)} {...props}>
      <MediaThumbnail media={media} marginLeft="10px" pdfThumbnailClassName={styles.pdfThumbnail} />
      <CardBody className={styles.cardBody}>
        <CardTitle className={styles.mediaCaption}>
          <InlineTextField
            style={{ width: '85%' }}
            value={media.name}
            onApplyChange={onChangeCaption}
            noedit
            editFirst={editing}
            onStopEdit={() => setEditing(false)}
          />
        </CardTitle>
        <CardText className={styles.mediaName}>
          {media?.mediaType === MediaType.IMAGE && (media?.originalFile || media?.image || media?.originalImage)}
          {media?.mediaType === MediaType.FILE && (media.originalFile || media.document)}
          {media?.mediaType === MediaType.VIDEO && (media.originalFile || media.video || media.url)}
          {media?.mediaType === MediaType.EMBED_LINK && media.url}
        </CardText>
      </CardBody>
      <DropdownMenu color="light" className={styles.actionMenu} placeholder="...">
        {!noEditCaption && <DropdownItem onClick={() => setEditing(true)}>Caption</DropdownItem>}
        <DropdownItem style={{ color: 'red' }} onClick={handleDeleteMedia}>
          Delete
        </DropdownItem>
      </DropdownMenu>
    </Card>
  )
}

export default observer(MediaItem)
